import { c as _c } from "react/compiler-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import { isNotFoundError, isNotLoggedInError, isPermissionError, isTimeoutError, getPreferredErrorMessage, isTRPCClientError, isNetworkError } from '@newfront-insurance/data-layer-client';
import * as React from 'react';
import type { JSX } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorMessage } from './components/error-message';
import type { ErrorBoundaryContainer, ErrorBoundaryMessages, ErrorCallback, ErrorMessageProps } from './types';
interface Props {
  children: React.ReactNode;
  messages: ErrorBoundaryMessages;
  onError?: ErrorCallback;
  container?: ErrorBoundaryContainer;
}
export function ErrorBoundaryWithMessages(t0) {
  const $ = _c(7);
  const {
    children,
    onError,
    messages,
    container
  } = t0;
  const Container = container ?? ErrorMessage;
  let t1;
  if ($[0] !== Container || $[1] !== messages) {
    t1 = t2 => {
      const {
        error
      } = t2;
      const message = getPreferredErrorMessage(error);
      const errorCause = isTRPCClientError(error) && error.cause ? error.cause : error;
      let errorProps;
      if (isPermissionError(errorCause)) {
        messages.permissionError(errorCause);
      } else {
        if (isTimeoutError(errorCause)) {
          messages.timeoutError(errorCause);
        } else {
          if (isNetworkError(errorCause)) {
            messages.networkError(errorCause);
          } else {
            if (isNotFoundError(errorCause)) {
              messages.notFoundError(errorCause);
            } else {
              if (isNotLoggedInError(errorCause)) {
                messages.notLoggedInError(errorCause);
              }
            }
          }
        }
      }
      errorProps = {
        ...messages.genericError(errorCause),
        rawErrorMessage: message
      };
      return <Container {...errorProps} />;
    };
    $[0] = Container;
    $[1] = messages;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== onError || $[5] !== t1) {
    t2 = <ErrorBoundary onError={onError} fallbackRender={t1}>{children}</ErrorBoundary>;
    $[3] = children;
    $[4] = onError;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}